import { ActivatedRoute, Router } from '@angular/router';
import { AppInjector } from 'src/app/core/services/app-injector.service';
import { Subscription } from 'rxjs';
import { Injectable, OnInit } from '@angular/core';
import { getDepartmentTypeByRouteName } from 'src/app/core/constants';
import { TournamentService } from './tournament.service';
import { Location } from '@angular/common';

@Injectable()
export default abstract class TournamentBase {
    protected tournamentService: TournamentService;
    protected route: ActivatedRoute;
    protected router: Router;
    public location: Location;
    protected paramSubscription: Subscription;
    public tournamentView: 'list' | 'home' | 'enroll' = 'list';

    constructor() {
        const injector = AppInjector.getInjector();
        this.tournamentService = injector.get(TournamentService);
        this.route = injector.get(ActivatedRoute);
        this.router = injector.get(Router);
        this.location = injector.get(Location);
    }

    /**
     * defineViewType()
     * determina baseado na rota se
     * a renderização do component será
     * uma lista ou apenas um torneio selecionado
     */
    defineViewType() {
        this.paramSubscription = this.route.queryParams.subscribe((params) => {
            this.tournamentView = params.view || 'list';
        });
    }

    getDepartmentType() {
        const url = this.router.url.split('/');
        url.shift();
        const [deparmentRoute] = url;
        return getDepartmentTypeByRouteName(deparmentRoute);
    }

    ngOnDestroy() {
        if (!!this.paramSubscription) this.paramSubscription.unsubscribe();
    }
}
